import { Dispatch } from '~/xidrBiz/store/types'
import { ENDPOINTS, get } from '~/api'
import { XIDR_ACCOUNT_ACTIONS } from './const'
import { Account, AccountDetail, ActionTypes } from './types'
import { keysToCamel } from '~/helpers/helpers'

export const setAccountList = (accountList: Account[]) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: XIDR_ACCOUNT_ACTIONS.SET_ACCOUNT_LIST,
    accountList,
  })
}

export const setAccountDetailList = (accountDetailList: AccountDetail[]) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: XIDR_ACCOUNT_ACTIONS.SET_ACCOUNT_DETAIL_LIST,
    accountDetailList,
  })
}

export const fetchAccountList = (onSuccess?: () => void) => async (
  dispatch: Dispatch<ActionTypes>
) => {
  const resp = await get(ENDPOINTS.API_V3_STABLECOIN_ACCOUNTS)

  const accounts = keysToCamel(resp)
  dispatch(setAccountList(accounts as Account[]))

  if (onSuccess) {
    onSuccess()
  }
}

export const fetchAccountDetailList = (onSuccess?: () => void) => async (
  dispatch: Dispatch<ActionTypes>
) => {
  const resp = await get(ENDPOINTS.API_V3_STABLECOIN_ACCOUNTS_INFO_FOR_SDK)

  const accountDetails = keysToCamel(resp.data)
  dispatch(setAccountDetailList(accountDetails as AccountDetail[]))

  if (onSuccess) {
    onSuccess()
  }
}
